import { render, staticRenderFns } from "./AtomImageParallax.vue?vue&type=template&id=7d139758&scoped=true&"
import script from "./AtomImageParallax.vue?vue&type=script&lang=js&"
export * from "./AtomImageParallax.vue?vue&type=script&lang=js&"
import style0 from "./AtomImageParallax.vue?vue&type=style&index=0&id=7d139758&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d139758",
  null
  
)

export default component.exports